<template>
  <div>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-toggle.edit-sidebar
      :variant="variant"
    >
      <feather-icon :icon="icon" style="margin-left: 8px" />
      {{ label }}
    </b-button>
    <b-sidebar
      width="700px"
      id="edit-sidebar"
      shadow
      bg-variant="white"
      backdrop
    >
      <div
        style="height: 100%"
        class="d-flex flex-column justify-content-between"
      >
        <slot />
        <div class="mt-auto">
          <div style="width: fit-content" class="ml-auto mr-1 my-1">
            <slot name="actions" />
            <b-button ref="closeSideBar" v-b-toggle.edit-sidebar class="mx-1">
              <feather-icon icon="XCircleIcon" />

              <span class="mx-50">الغاء</span>
            </b-button>
            <b-button
              :disabled="loading"
              @click="$emit('dialogAccepted')"
              variant="success"
            >
              <template v-if="loading">
                <b-spinner class="align-middle mx-50" small />
                <span class="mx-50">جارٍ الحفظ</span>
              </template>
              <template v-else @click="onSubmit">
                <feather-icon icon="SaveIcon" />
                <span class="mx-50">حفظ</span>
              </template>
            </b-button>
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BButton,
  BSidebar,
  VBToggle,
  BFormInput,
  BFormCheckbox,
  BFormGroup,
  BContainer,
  BSpinner,
  BRow,
  BCol,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationObserver } from "vee-validate";
import { required, integer } from "@validations";

const initForm = {
  name: "",
  objectives: "",
  program_type: null,
};

export default {
  components: {
    BButton,
    BSidebar,
    BFormInput,
    BFormCheckbox,
    BContainer,
    BRow,
    BSpinner,
    BFormGroup,
    BCol,
    ValidationObserver,
  },
  data() {
    return {
      form: {},
      required,
      integer,
      options: [
        { id: "مرتبط بالخطة", name: "مرتبط بالخطة" },
        { id: "طارئ", name: "طارئ" },
      ],
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
  },
  directives: {
    "b-toggle": VBToggle,
    Ripple,
  },
  props: {
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
    label: {
      type: String,
      default: () => "",
    },
    icon: {
      type: String,
      default: () => "EditIcon",
    },
    variant: {
      type: String,
      default: () => "primary",
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.programValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.b-sidebar-body {
  scrollbar-width: thin;
}
</style>
